import { hydrateRoot } from 'react-dom/client';
import { RelayEnvironmentProvider } from 'react-relay';
import serverVars from 'server-vars';
import { initializeDBL } from 'dibs-buyer-layout/src/entries/index';
import { getRelayEnvironment } from '../utils/relayModernEnvironment';
import { NftCreatorsWrapper } from './NftCreatorsWrapper';
import { trackPageview } from 'dibs-tracking';

const environment = getRelayEnvironment({
    ...serverVars.get('dbl.relayData'),
});

initializeDBL().then(({ store }: { store: $TSFixMe }) => {
    hydrateRoot(
        document.getElementById('js-root') as HTMLElement,
        <RelayEnvironmentProvider environment={environment}>
            <NftCreatorsWrapper
                store={store}
                deviceType={serverVars.get('deviceType')}
                locale={serverVars.get('intlVariables.locale')}
                variables={serverVars.get('relayVariables')}
            />
        </RelayEnvironmentProvider>
    );
    trackPageview({
        additional: {
            pageType: 'Other',
            pageSubType: `NFT Marketplace`,
        },
    });
});
